import { Injectable } from '@angular/core';
import { Context } from '../model/context';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from "rxjs/operators";
import { Upload } from '../model/upload';

@Injectable({providedIn: 'root'})
export class PublicService {

  constructor(private http: HttpClient) { }

  getContextByGroupement(groupement: string): Observable<Context> {

    let url = (groupement === 'local' ? 'assets/data/local.json' : 'https://opticreche.fr/confs/' + groupement + '.json');

    return this.http.get<any>(url)
      .pipe(
        map(data => { 
          const c = new Context();
          
          c.logo = data.logo;
          c.test = data.test;
          if (data.singlePage) c.singlePage = data.singlePage;
          if (data.sections) c.sections = data.sections;
          if (data.primaryColor) c.primaryColor = data.primaryColor;
          if (data.accentColor) c.accentColor = data.accentColor;
          if (data.bgColor) c.bgColor = data.bgColor;
          if (data.apiRoot) c.apiRoot = data.apiRoot;
          c.monoCible = data.monoCible;
          c.cibles = data.cibles;
          c.textes = data.textes;
          c.urlRedirection = data.urlRedirection;
          if (!c.test) c.options = data.options;
          return c;
        }),
        catchError((error: HttpErrorResponse) => { return this.getContextByGroupement('local'); })
      );
  }

  sendDemand(upload: Upload, context: Context): Observable<any> {
    let url = "https://app.opticreche.fr/api/v4/public/admission"; 
    if (context.apiRoot != null && context.apiRoot != '') url = context.apiRoot;
    return this.http.post<any>(url, upload);
  }

  sendMetric(data: any): Observable<any> {
    const metric = {
      applicationKey: 'KEY-PROD',
      date: new Date().toISOString().replace('Z', ''),
      userType: 'EXTERNAL',
      userId: 0,
      crecheId: 0,
      component: 'FormAdmission',
      action: 'submit',
      duration: 0,		
      parameters: JSON.stringify(data), 
      exception: null,
      stack: null		                    		   			
    };

    return this.http.post<any>("https://metrics.opticreche.fr/api/public/event", metric);
  }
}